import React, { useState } from 'react';
import { Button } from '@marriott/mi-ui-library';
import moment from 'moment';
import { TextBlock } from '../../../../molecules';
import { getFormattedDate } from '../../../../utils/date';
import { ContactInfoSummary } from '../../../../molecules/ContactInfoSummary';
import { ContactInfoSummaryMock } from '../../../../molecules/ContactInfoSummary/__mock__/__mock__';
import { EVENT_CONFIRMATION_LABELS } from '../../../asp-constants';
import data from './__mock__/EventConfirmationDetails.model.json';
import { StyledEventConfirmationDetails, StyledConfirmationSection } from './EventConfirmationDetails.styles';
import { ResendQGConfirmationEmail } from './ResendQGConfirmationEmail';

export const EventConfirmationDetails = () => {
  const { resendEmailCTA, confirmationBanner, contactInfoSummary, resendConfirmationModal } = EVENT_CONFIRMATION_LABELS;
  const { eventDate, bookingDate, ...labels } = confirmationBanner;

  const [showResendConfirmationModal, setShowResendConfirmationModal] = useState(false);

  const confirmationData = data.confirmationData;

  const contactData = ContactInfoSummaryMock.data;

  const eventTypeValue =
    confirmationData.guestRoomsData.eventType.label || confirmationData.eventSpacesData.eventType.label;

  const toggleShowResendConfirmationModal = () => setShowResendConfirmationModal(prev => !prev);

  return (
    <StyledEventConfirmationDetails
      data-testid="groups-EventConfirmationDetails"
      data-component-name="o-groups-EventConfirmationDetails"
    >
      <div className="mb-3">
        <StyledConfirmationSection className="d-flex p-4 p-md-5 confirmation-body">
          <div className="pb-4 pb-md-0 pr-md-4 property-details">
            <div className="mb-3">
              <Button
                callback={toggleShowResendConfirmationModal}
                className="m-buttom-l m-button-primary button"
                ariaLabel={resendEmailCTA}
              >
                {resendEmailCTA}
              </Button>
            </div>
            <TextBlock
              label={confirmationData.isSubmitInquiry ? labels.trackingNumber : labels.confirmationNumber}
              value={confirmationData.id}
              customClass="text-block"
            />
          </div>
          <div className="pt-4 pt-md-0 pl-md-4 booking-details">
            <div className="row">
              <TextBlock
                label={confirmationData.isSubmitInquiry ? eventDate : bookingDate}
                value={`${getFormattedDate(moment(confirmationData.startDate as string))} - ${getFormattedDate(
                  moment(confirmationData.endDate as string)
                )}`}
                customClass="col-12 text-block"
              />
              <TextBlock label={labels.eventName} value={confirmationData.eventName} customClass="col-6 text-block" />
              <TextBlock label={labels.eventType} value={eventTypeValue} customClass="col-6 text-block" />

              <TextBlock
                label={labels.guestRooms || ''}
                value={`${confirmationData.numberOfGuests || 0}`}
                customClass="col-6 text-block"
              />

              <TextBlock
                label={labels.eventSpace || ''}
                value={`${confirmationData.numberOfAttendees || 0}`}
                customClass="col-6 text-block"
              />
              {confirmationData.joinMarriottBonvoy && (
                <TextBlock
                  label={labels.rewardsId}
                  value={confirmationData.joinMarriottBonvoy ? confirmationData.rewardId : ''}
                  customClass="col-md-6 col-lg-4 text-block"
                />
              )}
            </div>
          </div>
        </StyledConfirmationSection>
        <StyledConfirmationSection className="mt-3 standard">
          <ContactInfoSummary labels={contactInfoSummary} data={contactData} />
        </StyledConfirmationSection>
      </div>
      {showResendConfirmationModal && (
        <ResendQGConfirmationEmail
          rfpId={confirmationData.id}
          show={showResendConfirmationModal}
          onClose={toggleShowResendConfirmationModal}
          labels={resendConfirmationModal}
        />
      )}
    </StyledEventConfirmationDetails>
  );
};
